import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./calcite-button.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./calcite-button.component.css?ngResource";
import { Component, Input, ViewChild } from '@angular/core';
export let CalciteButtonComponent = class CalciteButtonComponent {
    btnRef;
    displayText = "Button";
    appearance = "solid" /* CalciteBtnAppearance.solid */;
    color = "blue" /* CalciteBtnColor.blue */;
    disable = false;
    width = "auto" /* CalciteBtnWidth.auto */;
    class = "calcite-theme-light" /* CalciteBtnClass.lightTheme */;
    constructor() {
    }
    ngOnInit() {
        this.setBtnText();
    }
    setBtnText() {
        if (this.displayText) {
            this.displayText = this.displayText[0].trim().toUpperCase() + this.displayText.trim().substr(1).toLowerCase();
        }
    }
    static ctorParameters = () => [];
    static propDecorators = {
        btnRef: [{ type: ViewChild, args: ['btnRef',] }],
        displayText: [{ type: Input }],
        appearance: [{ type: Input }],
        color: [{ type: Input }],
        disable: [{ type: Input }],
        width: [{ type: Input }],
        class: [{ type: Input }]
    };
};
CalciteButtonComponent = __decorate([
    Component({
        selector: 'lib-calcite-button',
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CalciteButtonComponent);
